export default  {
    component: 'mfm',
    name: 'mfm',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Block ID',
            param: 'block_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> Should always start from ID **"1"**`
          },
          {
            name: 'Inverter Room',
            param: 'inverter_room',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, by default we add it as **"0"**. Otherwise it should start from **"1"** for each block.`
          },
          {
            name: 'Feeder ID',
            param: 'feeder_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each Block-Room, feeder id should start from **"1"**`
          },
          {
            name: 'Device ID',
            param: 'device_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `The contactions of device id should be added as *\(e.g. 1-1-1)`
          },
          {
            name: 'Feeder Name',
            param: 'feeder_name',
            type: 'text',
            description: `> For each block room name should be unique`
          },
          {
            name: 'AC Capacity',
            param: 'ac_capacity',
            type: 'number',
            description: `Its a mandatory data for the calculation of **"PR"**. It should be sum of all the inverters capacities present in that specific Block-Room.`
          },
          {
            name: 'DC Capacity',
            param: 'dc_capacity',
            type: 'number',
            description: `Its a mandatory data. It should be sum of all the inverters capacities present in that specific room`
          },
          {
            name: 'Transformer List',
            param: 'transformer_list',
            type: 'text',
          },
          {
            name: 'Reading frequency',
            param: 'reading_frequency',
            type: 'number',
            description: `It varies from plants few we recieve data at interval of 5 min so we need to add frequency as **"5"** in order to show connectivity in graph.`
          },
          {
            name: 'Latitude',
            param: 'latitude',
            type: 'number',
          },
          {
            name: 'Longitude',
            param: 'longitude',
            type: 'number',
          },
          {
            name: 'Param Config',
            param: 'param_config',
            type: 'json',
          },
          {
            name: 'Filter Config',
            param: 'filter_config',
            type: 'json',
            description: `For junk cleaner module we add threshold value for parameter.
            - Json :  "{"validationRules": {"active_total_export_cumulative": {"cumulative": {"threshold": 28}}}}"`
          },
          {
            name: 'Parameter List',
            param: 'param_list',
            type: 'text',
            description: `In order to remove unwanted parameters from analytics. *\(e.g rm-efficiency,em-voltage_supply)`
          },
          {
            name: 'Name Config',
            param: 'name_config',
            type: 'text',
            description: `The name should be unique. Name Concatination of Block Name-Room Name-Device Name`
          },
          {
            name: 'Make',
            param: 'make',
            type: 'text',
          },
          {
            name: 'Type',
            param: 'type',
            type: 'text',
            description: `Their are two types option:
            - **incomer**
            - **Outgoing**
            Based on mfm detail is added`
          },
          {
            name: 'Model',
            param: 'model',
            type: 'text',
          }
    ]
  }